import { Trans, useTranslation } from 'react-i18next'

import { Alert, ComboBox, Link } from '@reveni-io/reveni-ui'

import { subscriptionPlans } from '@/common/constants'
import { exchangeMethods, preferences } from '@/configuration/pages/ConfigurationPage/constants'
import { shouldHaveOtherProductVariants } from '@/configuration/pages/ConfigurationPage/helpers'
import { providers } from '@/returns/constants'
import routes from '@/Router/routes.constants'

const AllowedExchangeMethodsSelector = ({
  allowedPreferences,
  allowedExchangeMethods,
  setAllowedExchangeMethods,
  provider,
  configurationPreferences,
  subscriptionPlan,
  externalConnectedGateway,
  disabled,
}) => {
  const { t } = useTranslation()

  const getAllowedExchangeMethodValue = () => {
    return allowedExchangeMethods?.length > 1 ? 'both' : allowedExchangeMethods?.[0]
  }

  const handleChangeExchangeMethod = e => {
    const value = e.target.value

    if (value === 'both') {
      setAllowedExchangeMethods([
        exchangeMethods.sameProductVariants,
        shouldHaveOtherProductVariants(
          provider,
          configurationPreferences?.allowed_exchange_methods,
          externalConnectedGateway
        )
          ? exchangeMethods.otherProductVariants
          : exchangeMethods.otherProducts,
      ])
    } else {
      setAllowedExchangeMethods([e.target.value])
    }
  }

  const getValueForOtherProducts = () => {
    return shouldHaveOtherProductVariants(
      provider,
      configurationPreferences?.allowed_exchange_methods,
      externalConnectedGateway
    )
      ? exchangeMethods.otherProductVariants
      : exchangeMethods.otherProducts
  }

  const shouldShowExternalGatewayConnectInfo = () => {
    return !externalConnectedGateway && provider === providers.prestashop
  }

  if (
    !allowedPreferences.includes(preferences.allowedExchangeMethods) ||
    subscriptionPlan !== subscriptionPlans.premium
  ) {
    return null
  }

  return (
    <>
      <ComboBox
        label={t('Tipos de cambios permitidos')}
        menuItems={[
          { label: t('Variantes (talla/color...)'), value: exchangeMethods.sameProductVariants },
          {
            label: t('Otros productos'),
            value: getValueForOtherProducts(),
          },
          { label: t('Variantes y Otros productos'), value: 'both' },
        ]}
        value={getAllowedExchangeMethodValue()}
        handleChange={handleChangeExchangeMethod}
        fullWidth
        disabled={disabled}
      />
      {shouldShowExternalGatewayConnectInfo() && (
        <Alert type="info">
          <Trans
            i18nKey="externalGatewayConnectInfo"
            components={{
              email: <Link href="mailto:merchants@reveni.io" />,
              integrationsLink: <Link href={routes.configurationPage.integrations} />,
            }}
          >
            Solicita acceso a nuestro equipo en <Link href="mailto:merchants@reveni.io">merchants@reveni.io</Link> y
            habilita la conexión con una pasarela de pago externa en{' '}
            <Link href={routes.configurationPage.integrations}>Configuración &gt; Integraciones</Link> para automatizar
            los cobros de los cambios por otros productos.
          </Trans>
        </Alert>
      )}
    </>
  )
}

export default AllowedExchangeMethodsSelector
